import styled from 'styled-components';

import type { IconDefinition } from 'atoms/icons';
import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal } from 'atoms/layout/flex';

import type { Props as ButtonProps } from '../Button';
import { Button } from '../Button';

export interface Props extends Omit<ButtonProps, 'startIcon'> {
  icon?: IconDefinition;
}

const Root = styled(Button)`
  padding: 0;
  display: flex;
  align-items: center;
  width: calc(6 * var(--unit));
  height: calc(6 * var(--unit));
  border-radius: 2em;
  &[aria-disabled='true'] {
    opacity: 0.5;
    pointer-events: none;
  }
  &.compact {
    padding: 0;
    width: var(--triple-unit);
    height: var(--triple-unit);
  }
  &.small {
    padding: 0;
    width: var(--quadruple-unit);
    height: var(--quadruple-unit);
  }
  &.medium {
    padding: 0;
    width: calc(5 * var(--unit));
    height: calc(5 * var(--unit));
  }
`;
const Label = styled(Horizontal).attrs({ center: true, as: 'span' })`
  && {
    font-size: 16px;
    line-height: 12px;
  }
`;

export const IconButton = (props: Props) => {
  const { children, icon, ref, ...rest } = props;

  return (
    <Root ref={ref} {...rest}>
      <Label>{icon ? <FontAwesomeIcon icon={icon} /> : children}</Label>
    </Root>
  );
};
